import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import ProfileSidebar from '../components/profile/ProfileSidebar';
import { getUserSession } from '../services/authService';
import {
  fetchUserNotifications,
  formatNotificationTime,
  getNotificationInitials,
  getNotificationTypeLabel,
} from '../services/notificationsService';
import '../styles/profile.css';

const SystemNotificationIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

const NotificationAvatar = ({ notification }) => {
  if (notification.tipo === 'sistema' && !notification.avatar_url) {
    return (
      <span className="profile-notification-avatar profile-notification-avatar--system">
        <SystemNotificationIcon />
      </span>
    );
  }

  if (notification.avatar_url) {
    return (
      <span
        className="profile-notification-avatar"
        style={{ backgroundImage: `url(${notification.avatar_url})` }}
        role="img"
        aria-label={notification.autor_nombre || 'Notificación'}
      />
    );
  }

  return (
    <span className="profile-notification-avatar profile-notification-avatar--initials">
      {getNotificationInitials(notification)}
    </span>
  );
};

const ProfileNotificationsPage = () => {
  const sessionUser = getUserSession();
  const sessionUserId = sessionUser ? sessionUser.id : null;
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadWarning, setLoadWarning] = useState('');

  useEffect(() => {
    if (!sessionUserId) {
      setIsLoading(false);
      return;
    }

    fetchUserNotifications(sessionUserId)
      .then((data) => {
        setNotifications(data.notificaciones || []);
        setLoadWarning('');
      })
      .catch((error) => {
        setLoadWarning(error.message || 'No se pudieron cargar las notificaciones.');
        setNotifications([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [sessionUserId]);

  if (!sessionUser) {
    return <Redirect to="/iniciar-sesion" />;
  }

  return (
    <div className="profile-root">
      <div className="profile-layout">
        <ProfileSidebar activeId="notificaciones" />

        <section className="profile-main">
          {isLoading ? <p className="profile-status">Cargando notificaciones...</p> : null}

          {!isLoading && loadWarning ? (
            <p className="profile-status profile-status--warning">{loadWarning}</p>
          ) : null}

          {!isLoading && !loadWarning && notifications.length === 0 ? (
            <p className="profile-status">No tienes notificaciones por ahora.</p>
          ) : null}

          {!isLoading && notifications.length > 0 ? (
            <div className="profile-notifications-list">
              {notifications.map((notification) => (
                <article key={notification.id} className="profile-notification-item">
                  <NotificationAvatar notification={notification} />

                  <div className="profile-notification-content">
                    <div className="profile-notification-meta">
                      <span
                        className={`profile-notification-tag profile-notification-tag--${notification.tipo}`}
                      >
                        {getNotificationTypeLabel(notification.tipo)}
                      </span>
                      <time className="profile-notification-time" dateTime={notification.creado_en}>
                        {formatNotificationTime(notification.creado_en)}
                      </time>
                    </div>

                    <p className="profile-notification-message">
                      {notification.autor_nombre ? (
                        <>
                          <strong>{notification.autor_nombre}</strong> {notification.mensaje}
                        </>
                      ) : (
                        notification.mensaje
                      )}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          ) : null}
        </section>
      </div>
    </div>
  );
};

export default ProfileNotificationsPage;
